<template>
  <div class="search-content">
    <router-view ref="tab"/>
  </div>
</template>

<script>
export default {
  name: 'WorkLayout',
  data () {
    return {
      tabs: {
        items: [
          {
            key: '1',
            title: this.$t('menu.menuSearch')
          },
          {
            key: '2',
            title: this.$t('menu.recentlyVisited')
          }
        ],
        active: () => {
          switch (this.$route.path) {
            case '/settings/workLayout/menuSearch':
              return '1'
            case '/settings/workLayout/recentView':
              return '2'
            default:
              return '1'
          }
        },
        callback: (key) => {
          switch (key) {
            case '1':
              this.$router.push('/settings/workLayout/menuSearch').catch(err => {})
              break
            case '2':
              this.$router.push('/settings/workLayout/recentView').catch(err => {})
              break
            default:
              this.$router.push('/settings/workLayout').catch(err => {})
          }
        }
      },
      search: true
    }
  },
  computed: {

  },
  methods: {
    searchInput(text){
      this.$refs.tab.search(text)
    }
  }
}
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
